<template>
  <div :class="classes" @mousedown.prevent>
    <top-tabs
      :dynamic="isDynamic"
      :dynamicRangeText="dynamicRangeText"
      :stringValue="publicStringValue"
      :static-only="staticOnly"
      @change-text="changeRangeText"
      @on-change="handleDynamicClick"
    >
    </top-tabs>

    <div :class="[prefixCls + '-sidebar']" v-if="shortcuts.length">
      <div class="overlay-shortcuts" v-show="isCompared"></div>
      <div
        v-for="(shortcut, index) in shortcuts"
        :class="[
          prefixCls + '-shortcut',
          'pre-shortcut',
          shortcutChecked(shortcut.text),
        ]"
        :style="{ width: index > 7 ? '100%' : '50%' }"
        @click="handleShortcutClick(shortcut)"
      >
        {{ shortcut.text }}
      </div>
    </div>
    <div :class="panelBodyClasses">
      <div
        :class="[prefixCls + '-content', prefixCls + '-content-left']"
        v-show="!isTime"
      >
        <div
          :class="[datePrefixCls + '-header']"
          v-show="currentView !== 'time'"
        >
          <span :class="iconBtnCls('prev', '-double')" @click="prevYear('left')"
            ><Icon type="ios-arrow-back"></Icon
          ></span>
          <span
            v-if="leftPickerTable === 'date-table'"
            :class="iconBtnCls('prev')"
            @click="prevMonth('left')"
            v-show="currentView === 'date'"
            ><Icon type="ios-arrow-back"></Icon
          ></span>
          <date-panel-label
            :date-panel-label="leftDatePanelLabel"
            :current-view="leftDatePanelView"
            :date-prefix-cls="datePrefixCls"
          ></date-panel-label>
          <span
            v-if="splitPanels || leftPickerTable !== 'date-table'"
            :class="iconBtnCls('next', '-double')"
            @click="nextYear('left')"
            ><Icon type="ios-arrow-forward"></Icon
          ></span>
          <span
            v-if="splitPanels && leftPickerTable === 'date-table'"
            :class="iconBtnCls('next')"
            @click="nextMonth('left')"
            v-show="currentView === 'date'"
            ><Icon type="ios-arrow-forward"></Icon
          ></span>
        </div>
        <component
          :is="leftPickerTable"
          ref="leftYearTable"
          v-if="currentView !== 'time'"
          :table-date="leftPanelDate"
          selection-mode="range"
          :disabled-date="disabledDate"
          :range-state="rangeState"
          :compared-range="comparedRange"
          :public-string-value="publicStringValue"
          :is-compared="isCompared"
          :show-week-numbers="showWeekNumbers"
          :value="preSelecting.left ? [dates[0]] : dates"
          :focused-date="focusedDate"
          @on-change-range="handleChangeRange"
          @on-pick="panelPickerHandlers.left"
          @on-pick-click="handlePickClick"
        ></component>
      </div>
      <div
        :class="[prefixCls + '-content', prefixCls + '-content-right']"
        v-show="!isTime"
      >
        <div
          :class="[datePrefixCls + '-header']"
          v-show="currentView !== 'time'"
        >
          <span
            v-if="splitPanels || rightPickerTable !== 'date-table'"
            :class="iconBtnCls('prev', '-double')"
            @click="prevYear('right')"
            ><Icon type="ios-arrow-back"></Icon
          ></span>
          <span
            v-if="splitPanels && rightPickerTable === 'date-table'"
            :class="iconBtnCls('prev')"
            @click="prevMonth('right')"
            v-show="currentView === 'date'"
            ><Icon type="ios-arrow-back"></Icon
          ></span>
          <date-panel-label
            :date-panel-label="rightDatePanelLabel"
            :current-view="rightDatePanelView"
            :date-prefix-cls="datePrefixCls"
          ></date-panel-label>
          <span
            :class="iconBtnCls('next', '-double')"
            @click="nextYear('right')"
            ><Icon type="ios-arrow-forward"></Icon
          ></span>
          <span
            v-if="rightPickerTable === 'date-table'"
            :class="iconBtnCls('next')"
            @click="nextMonth('right')"
            v-show="currentView === 'date'"
            ><Icon type="ios-arrow-forward"></Icon
          ></span>
        </div>
        <component
          :is="rightPickerTable"
          ref="rightYearTable"
          v-if="currentView !== 'time'"
          :table-date="rightPanelDate"
          selection-mode="range"
          :range-state="rangeState"
          :compared-range="comparedRange"
          :public-string-value="publicStringValue"
          :is-compared="isCompared"
          :disabled-date="disabledDate"
          :show-week-numbers="showWeekNumbers"
          :value="preSelecting.right ? [dates[dates.length - 1]] : dates"
          :focused-date="focusedDate"
          @on-change-range="handleChangeRange"
          @on-pick="panelPickerHandlers.right"
          @on-pick-click="handlePickClick"
        ></component>
      </div>
      <div :class="[prefixCls + '-content']" v-show="isTime">
        <time-picker
          ref="timePicker"
          v-if="currentView === 'time'"
          :value="dates"
          format="HH:mm"
          :time-disabled="timeDisabled"
          v-bind="timePickerOptions"
          @on-pick="handleRangePick"
          @on-pick-click="handlePickClick"
          @on-pick-clear="handlePickClear"
          @on-pick-success="handlePickSuccess"
          @on-pick-toggle-time="handleToggleTime"
        ></time-picker>
      </div>
      <Confirm
        v-if="confirm"
        ref="confirmBar"
        :show-time="showTime"
        :is-time="isTime"
        :time-disabled="timeDisabled"
        :compare-date="compareDate"
        :compared-range="comparedRange"
        :is-compared="isCompared"
        :limit="limit"
        :showLimit="showLimit"
        :term="term"
        @on-range-type-change="handleChangeRangeType"
        @on-compare="handleToggleCompare"
        @on-com-end="handleToggleCompareend"
        @on-pick-toggle-time="handleToggleTime"
        @on-pick-clear="handlePickClear"
        @on-pick-success="handlePickSuccess"
      ></Confirm>
    </div>
  </div>
</template>
<script>
import Icon from "view-design/src/components/icon/icon.vue";
import DateTable from "../../base/date-table.vue";
import YearTable from "../../base/year-table.vue";
import MonthTable from "../../base/month-table.vue";
import TimePicker from "../Time/time-range.vue";
import Confirm from "../../base/confirm.vue";
import dayjs from 'dayjs'
import { toDate, initTimeDate, formatDateLabels } from "../../util";
import { setDynamicText } from "../../tools/top-tabs/dynamic-text";
import datePanelLabel from "./date-panel-label.vue";

import TopTabs from "../../tools/top-tabs/top-tabs";

import Mixin from "../panel-mixin";
import DateMixin from "./date-panel-mixin";
import Locale from "view-design/src/mixins/locale";

const prefixCls = "ivu-picker-panel";
const datePrefixCls = "ivu-date-picker";

const dateSorter = (a, b) => {
  if (!a || !b) return 0;
  return a.getTime() - b.getTime();
};

let initOpen = false
export default {
  name: "RangeDatePickerPanel",
  mixins: [Mixin, Locale, DateMixin],
  inject: ['picker'],
  components: {
    Icon,
    DateTable,
    YearTable,
    MonthTable,
    TimePicker,
    Confirm,
    datePanelLabel,
    TopTabs,
  },
  props: {
    // more props in the mixin
    splitPanels: {
      type: Boolean,
      default: false,
    },
    publicStringValue: {
      type: Array,
      default: () => [null, null],
    },
    compareDate: {
      type: Boolean,
      default: false,
    },
    showLimit: {
      type: Boolean,
      default: false,
    },
    comparedDesc: {
      type: Object,
      default: () => ({}),
    },
    limit: {
      type: Boolean,
    },
    dynamicTime: {
      type: Boolean,
      default: false,
    },
    term: {
      type: String,
      default: "",
    },
    staticOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const [minDate, maxDate] = this.value.map((date) => date || initTimeDate());
    const leftPanelDate = this.startDate ? this.startDate : minDate;

    return {
      clickToggle: false,
      isDynamic: this.dynamicTime,
      dynamicRangeText: "",
      dynamicRangeType: "",
      isCompared: !!this.comparedDesc.from || false,
      prefixCls: prefixCls,
      datePrefixCls: datePrefixCls,
      dates: this.value,
      rangeState: {
        from: this.value[0],
        to: this.value[1],
        selecting: minDate && !maxDate,
      },
      comparedRange: {
        from: this.comparedDesc.from || null,
        to: this.comparedDesc.to || null,
        selecting: false,
      },
      currentView: this.selectionMode || "range",
      leftPickerTable: `${this.selectionMode}-table`,
      rightPickerTable: `${this.selectionMode}-table`,
      leftPanelDate: leftPanelDate,
      rightPanelDate: new Date(
        leftPanelDate.getFullYear(),
        leftPanelDate.getMonth() + 1,
        1
      ),
    };
  },
  computed: {
    classes() {
      return [
        `${prefixCls}-body-wrapper`,
        `${datePrefixCls}-with-range`,
        {
          [`${prefixCls}-with-sidebar`]: this.shortcuts.length,
          [`${datePrefixCls}-with-week-numbers`]: this.showWeekNumbers,
        },
      ];
    },
    panelBodyClasses() {
      return [
        prefixCls + "-body",
        {
          [prefixCls + "-body-time"]: this.showTime,
          [prefixCls + "-body-date"]: !this.showTime,
        },
      ];
    },
    leftDatePanelLabel() {
      return this.panelLabelConfig("left");
    },
    rightDatePanelLabel() {
      return this.panelLabelConfig("right");
    },
    leftDatePanelView() {
      return this.leftPickerTable.split("-").shift();
    },
    rightDatePanelView() {
      return this.rightPickerTable.split("-").shift();
    },
    timeDisabled() {
      return this.isCompared && !(this.dates[0] && this.dates[1]);
    },
    preSelecting() {
      const tableType = `${this.currentView}-table`;

      return {
        left: this.leftPickerTable !== tableType,
        right: this.rightPickerTable !== tableType,
      };
    },
    panelPickerHandlers() {
      return {
        left: this.preSelecting.left
          ? this.handlePreSelection.bind(this, "left")
          : this.handleRangePick,
        right: this.preSelecting.right
          ? this.handlePreSelection.bind(this, "right")
          : this.handleRangePick,
      };
    },
  },
  watch: {
    'picker.visible' () {
      if (this.picker.visible) {
        console.log('333????')
        this.clickToggle = true
        initOpen = true
      }
    },
    value(newVal) {
      const minDate = newVal[0] ? toDate(newVal[0]) : null;
      const maxDate = newVal[1] ? toDate(newVal[1]) : null;
      this.dates = [minDate, maxDate].sort(dateSorter);

      this.rangeState = {
        from: this.dates[0],
        to: this.dates[1],
        selecting: false,
      };

      this.dynamicRangeText = setDynamicText(newVal);
      // set panels positioning
      this.setPanelDates(this.startDate || this.dates[0] || new Date());
    },
    dynamicTime(bool) {
      this.isDynamic = bool;
    },
    comparedDesc(desc) {
      this.isCompared = !!desc.from;
      this.comparedRange = {
        from: new Date(desc.from),
        to: new Date(desc.to),
        selecting: false,
      };
    },
    currentView(currentView) {
      const leftMonth = this.leftPanelDate.getMonth();
      const rightMonth = this.rightPanelDate.getMonth();
      const isSameYear =
        this.leftPanelDate.getFullYear() === this.rightPanelDate.getFullYear();

      if (currentView === "date" && isSameYear && leftMonth === rightMonth) {
        this.changePanelDate("right", "Month", 1);
      }
      if (currentView === "month" && isSameYear) {
        this.changePanelDate("right", "FullYear", 1);
      }
      if (currentView === "year" && isSameYear) {
        this.changePanelDate("right", "FullYear", 10);
      }
    },
    selectionMode(type) {
      this.currentView = type || "range";
    },
    focusedDate(date) {
      this.setPanelDates(date || new Date());
    },
  },
  methods: {
    // 切换顶部时间类型
    handleDynamicClick(bool) {
      this.isDynamic = bool;
      this.$emit("on-dynamic-change", bool);
    },
    changeRangeText(text) {
      this.dynamicRangeText = text;
    },
    shortcutChecked(text) {
      const map = {
        '今年': 'year',
        '本周': 'week',
        '本月': 'month',
      }
      if (!this.clickToggle || initOpen) {
        setTimeout(() => {
            initOpen = false
        }, 300)
        if (map[this.dynamicRangeText]) {
          const val = map[this.dynamicRangeText]
          if (dayjs(this.dates[1]).endOf('day').valueOf() < dayjs().endOf(val).valueOf()) {
            return ''
          }
        }
      }

      return (this.dynamicRangeText === text) ? "shortcut-checked" : "";
    },
    handleToggleCompare(isCompare) {
      this.isCompared = isCompare;
      this.dates = [null, null];
      this.rangeState = {
        from: this.publicStringValue[0],
        to: this.publicStringValue[1],
        selecting: false,
      };
      if (!isCompare)
        this.comparedRange = {
          from: null,
          to: null,
          selecting: false,
        };
    },
    handleToggleCompareend(isCompare) {
      this.$emit("on-com-end", isCompare);
    },
    reset() {
      this.currentView = this.selectionMode;
      this.leftPickerTable = `${this.currentView}-table`;
      this.rightPickerTable = `${this.currentView}-table`;
    },
    setPanelDates(leftPanelDate) {
      this.leftPanelDate = leftPanelDate;
      const rightPanelDate = new Date(
        leftPanelDate.getFullYear(),
        leftPanelDate.getMonth() + 1,
        1
      );
      const splitRightPanelDate = this.dates[1]
        ? this.dates[1].getTime()
        : this.dates[1];
      this.rightPanelDate = this.splitPanels
        ? new Date(Math.max(splitRightPanelDate, rightPanelDate.getTime()))
        : rightPanelDate;
    },
    panelLabelConfig(direction) {
      const locale = this.t("i.locale");
      const datePanelLabel = this.t("i.datepicker.datePanelLabel");
      const handler = (type) => {
        const fn = type == "month" ? this.showMonthPicker : this.showYearPicker;
        return () => fn(direction);
      };

      const date = this[`${direction}PanelDate`];
      const { labels, separator } = formatDateLabels(
        locale,
        datePanelLabel,
        date
      );

      return {
        separator: separator,
        labels: labels.map((obj) => ((obj.handler = handler(obj.type)), obj)),
      };
    },
    prevYear(panel) {
      const increment = this.currentView === "year" ? -10 : -1;
      this.changePanelDate(panel, "FullYear", increment);
    },
    nextYear(panel) {
      const increment = this.currentView === "year" ? 10 : 1;
      this.changePanelDate(panel, "FullYear", increment);
    },
    prevMonth(panel) {
      this.changePanelDate(panel, "Month", -1);
    },
    nextMonth(panel) {
      this.changePanelDate(panel, "Month", 1);
    },
    changePanelDate(panel, type, increment, updateOtherPanel = true) {
      const current = new Date(this[`${panel}PanelDate`]);
      current[`set${type}`](current[`get${type}`]() + increment);
      this[`${panel}PanelDate`] = current;

      if (!updateOtherPanel) return;

      if (this.splitPanels) {
        // change other panel if dates overlap
        const otherPanel = panel === "left" ? "right" : "left";
        if (panel === "left" && this.leftPanelDate >= this.rightPanelDate) {
          this.changePanelDate(otherPanel, type, 1);
        }
        if (panel === "right" && this.rightPanelDate <= this.leftPanelDate) {
          this.changePanelDate(otherPanel, type, -1);
        }
      } else {
        // keep the panels together
        const otherPanel = panel === "left" ? "right" : "left";
        const currentDate = this[`${otherPanel}PanelDate`];
        const temp = new Date(currentDate);

        if (type === "Month") {
          const nextMonthLastDate = new Date(
            temp.getFullYear(),
            temp.getMonth() + increment + 1,
            0
          ).getDate();
          temp.setDate(Math.min(nextMonthLastDate, temp.getDate()));
        }

        temp[`set${type}`](temp[`get${type}`]() + increment);
        this[`${otherPanel}PanelDate`] = temp;
      }
    },
    showYearPicker(panel) {
      this[`${panel}PickerTable`] = "year-table";
    },
    showMonthPicker(panel) {
      this[`${panel}PickerTable`] = "month-table";
    },
    handlePreSelection(panel, value) {
      this[`${panel}PanelDate`] = value;
      const currentViewType = this[`${panel}PickerTable`];
      if (currentViewType === "year-table")
        this[`${panel}PickerTable`] = "month-table";
      else this[`${panel}PickerTable`] = `${this.currentView}-table`;

      if (!this.splitPanels) {
        const otherPanel = panel === "left" ? "right" : "left";
        this[`${otherPanel}PanelDate`] = value;

        const increment = otherPanel === "left" ? -1 : 1; // #3973

        this.changePanelDate(otherPanel, "Month", increment, false);
      }
    },
    handleRangePick(val, type) {
      this.dates = [];
      this.compareDate && this.$refs.confirmBar.clearRangeType();
      let currentRange = this.isCompared ? this.comparedRange : this.rangeState;
      if (currentRange.selecting || this.currentView === "time") {
        if (this.currentView === "time") {
          this.dates = val;
        } else {
          const [minDate, maxDate] = [currentRange.from, val].sort(dateSorter);
          this.dates = [minDate, maxDate];
          this.isCompared
            ? (this.comparedRange = {
                from: minDate,
                to: maxDate,
                selecting: false,
              })
            : (this.rangeState = {
                from: minDate,
                to: maxDate,
                selecting: false,
              });
        }
        !this.isCompared && this.handleConfirm(false, type || "date");
      } else {
        this.isCompared
          ? (this.comparedRange = {
              from: val,
              to: null,
              selecting: true,
            })
          : (this.rangeState = {
              from: val,
              to: null,
              selecting: true,
            });
      }
    },
    handleChangeRange(val) {
      if (!this.isCompared) this.rangeState.to = val;
      else this.comparedRange.to = val;
    },
    handleChangeRangeType(type) {
      const dynamicText = this.dynamicRangeText;
      const [start, end] = this.publicStringValue;
      const startTime = new Date(start).getTime();
      const endTime = new Date(end).getTime();
      const range = Math.floor((endTime - startTime) / 86400000);
      const startDate = new Date(start);
      let from = null,
        to = null,
        fromTime = null;

      this.dynamicRangeType = type;
      if (type === "previous") {
        // 上一时段
        if (/今天|昨天/.test(dynamicText)) {
          from = new Date(startTime - 86400000);
        } else if (/上周|本周/.test(dynamicText)) {
          from = new Date(startTime - 7 * 86400000);
        } else if (/上月|本月/.test(dynamicText)) {
          from = new Date(startDate.getFullYear(), startDate.getMonth() - 1, 1);
        } else if (/去年|今年/.test(dynamicText)) {
          from = new Date(startDate.getFullYear() - 1, 0, 1);
        } else {
          from = new Date(startTime - (range + 1) * 86400000);
        }
      } else {
        // 去年同期
        from = new Date(
          startDate.getFullYear() - 1,
          startDate.getMonth(),
          startDate.getDate()
        );
      }
      fromTime = new Date(from).getTime();
      to = new Date(fromTime + range * 86400000);
      this.dates = [from, to];
      this.comparedRange = { from, to, selecting: false };
    },
  },
};
</script>
<style scoped>
.overlay-shortcuts {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.5);
}

.pre-shortcut {
  text-align: center;
}

.pre-shortcut:hover {
  background: #e1f0fe;
}

.shortcut-checked,
.shortcut-checked:hover {
  background: #0084FF;
  color: #fff;
}

.ivu-picker-panel-body-wrapper.ivu-picker-panel-with-sidebar {
  padding-left: 184px;
}

.ivu-picker-panel-sidebar {
  display: flex;
  flex-wrap: wrap;
  padding: 40px 0 46px;
  width: 184px;
  margin-left: -184px;
  align-items: center;
  border-right-color: #dcdee2;
}

.ivu-picker-confirm {
  position: relative;
  left: -184px;
  bottom: -5px;
  width: calc(100% + 184px);
  padding: 12px;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/my-components/custom-date-picker/panel/Date/date-range.vue